export { default as AutoTestCardIcon } from './auto-test-card-icon';
export { default as DtmVirtualCardIcon } from './dtm-virtual-card-icon';